import { colors, styled } from "../../../../../../../../stitches.config";

export const BuilderFieldWrapper = styled("div", {
  backgroundColor: colors.bgUiSurface,
  marginBottom: "8px",
  padding: "8px 16px",
  borderWidth: "1px",
  borderStyle: "solid",
  border: `1px solid transparent`, // same color as background to avoid jitter
  borderRadius: "4px",
  cursor: "pointer",
  borderColor: colors.grey300,

  variants: {
    isSelected: {
      true: {
        borderColor: colors.borderUiFocused,
        backgroundColor: colors.bgUiInteraction,
      },
    },

    isGroupWrapper: {
      true: {
        borderColor: colors.grey300,
      },
    },
  },
});
